import React from 'react';
import { STATIC_FILE_URL } from '@/shared/constants';
import GrowSalesContent from './GrowSalesContent';
import { IFeaturedImage } from '@/shared/types/existing-brands';
import './index.less';

interface IGrowSalesContent {
  title: string;
  table: IFeaturedImage;
  description: string;
}

const GROW_SALES_CONTENT: IGrowSalesContent[] = [
  {
    title: `Sourcing & procurement`,
    table: {
      link: `${STATIC_FILE_URL}/fcfb8f36de711708edb07cb34720bb34.png`,
      width: 640,
      height: 331,
      title: `Sourcing & procurement`,
    },
    description: `Software to manage existing partners & access to 1300+ more vetted product, packaging, and merch factories to lower costs.`,
  },
  {
    title: `Marketing software`,
    table: {
      link: `${STATIC_FILE_URL}/4d1924eec09246a54d8dda350adee024.png`,
      width: 720,
      height: 331,
      title: `Marketing software`,
    },
    description: `Instantly add to Amazon & TikTok, access popular e-commerce software for free, and offload CX to Pietra.`,
  },
];

const GrowSales = () => {
  return (
    <div className="grow-sales">
      <div className="grow-sales-container">
        <div className="header">
          <h1>
            Compare <span>Pietra</span> to other options
          </h1>
          <p>All the sourcing and marketing services you need to operate profitably.</p>
        </div>
        <div className="content">
          {GROW_SALES_CONTENT.map((content) => (
            <GrowSalesContent key={`${content.title} ${content.table.link}`} {...content} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GrowSales;
